import { KPICard } from '@/components/lemmala-design-system/charts/kpi-card/kpi-card'
import type { MetricCardItem } from '@/components/lemmala-design-system/table/types'

type AgMetricCardsProps = {
  cards: MetricCardItem[]
  onCardClick: (card: MetricCardItem) => void
}

/** The row of quick-filter cards AgDataTable renders between the views switcher and the filter bar. */
export const AgMetricCards = ({ cards, onCardClick }: AgMetricCardsProps) => {
  if (cards.length === 0) return null

  return (
    <div className='flex shrink-0 flex-wrap gap-3'>
      {cards.map((card) => (
        <KPICard
          key={card.label}
          appearance='metric'
          label={card.label}
          value={String(card.count)}
          icon={card.icon}
          onClick={() => onCardClick(card)}
        />
      ))}
    </div>
  )
}
